import { AxiosInstance } from 'axios';
import type { GetWorkspaceTranscript } from './interfaces/workspace.transcript.js';

export class WorkspacesTranscriptClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  getWorkspaceTranscript = (data: GetWorkspaceTranscript.Request): Promise<GetWorkspaceTranscript.Response> => {
    return this.authenticatedClient.get<GetWorkspaceTranscript.Response>(`/workspaces/transcripts/${data.transcriptId}`)
      .then(res => res.data);
  };
}